import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { map, Observable, startWith } from 'rxjs';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
    selector: 'key-value-view',
    templateUrl: './key-value-view.component.html',
    styleUrls: ['./key-value-view.component.scss'],
    standalone: false
})
export class KeyValueViewComponent implements OnInit {

  @Input() formGroup:UntypedFormGroup;
  @Input() formArray:UntypedFormArray;
  @Input() sugestList:{key:string,value:string}[] = [];
  @Input() listKeySugest:string[] = [];
  @Input() title:string;
  @Input() subtitle:string;
  @Input() fieldname:string;
  keyCtrl = new UntypedFormControl();
  valueCtrl = new UntypedFormControl();
  filteredKeyOptions: Observable<string[]>;
  filteredValueOptions: Observable<string[]>= new Observable<string[]>();

  constructor(private snackBar:SnackbarService) { }

  ngOnInit(): void {
    
    this.formArray = this.formGroup.get(this.fieldname) as UntypedFormArray;
    this.listKeySugest = [...new Set(this.sugestList.map(item => item.key))].sort((a,b)=>{
          if ( a > b){
            return 1;
          }
          if ( a < b ){
            return -1;
          }
          return 0;
    });

    this.filteredKeyOptions = this.keyCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterKeyValue(value)),
    );

  }

  onkeyvalueKeySelected(event:MatAutocompleteSelectedEvent ){
    let dataValue = event.option.value;

    if ( dataValue !='' && dataValue!=null ){
      this.filteredValueOptions = new Observable<string[]>(d=>d.next(
        this.sugestList.filter(d=>d.key==dataValue).map(value =>value.value))
      );
    }else{
      this.filteredValueOptions = new Observable<string[]>(d=>d.next([])
      );
    }
  }

  private _filterKeyValue(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.listKeySugest.filter(option => option.toLowerCase().includes(filterValue));
  }


  addKeyUpkeyvalue(key: any, value:any){
    if (key == null || key == ''){
      this.snackBar.showError('Não informado a chave.');
      return;
    }

    if (value == null || value == ''){
      this.snackBar.showError('Não informado o valor.');
      return;
    }
    this.addValue(key+":"+value);
  }

  addValue(value: any): void {
    if (value) {
      this.formArray.push(new UntypedFormControl(value));
      this.keyCtrl.setValue('');
      
    }
  }

  removeValue(keyvalue: UntypedFormControl): void {

    let index = this.formArray.controls.findIndex(d=>d==keyvalue);
    
    if (index >= 0) {
      this.formArray.removeAt(index);
    }
  }


  

}
